import { createFileRoute, redirect } from '@tanstack/react-router';
import { callHistorySearchSchema } from '@/pages/calls/history/search-schema';

// Call history moved to `/calls`; keep old links (bookmarks, shared `?call=`
// URLs) working by forwarding them with their search params.
export const Route = createFileRoute('/_authenticated/call-history')({
  validateSearch: callHistorySearchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/calls', search, replace: true });
  },
});
